module.exports = __webpack_public_path__ + "static/img/pic_liucheng.b39de6e5.png";